<div class="drawer-overlay" (click)="onCancel()">
    <div class="drawer" (click)="onWindowClick($event)">
        <div class="drawer-header">
            <h3>{{'COMMON.ADD_FILTER.PLURAL' | translate}}</h3>
        </div>
         <div class="drawer-body">
            <ul>
                <!-- Region & Area Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('region')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0009 13.5417V16.875M10.0009 13.5417H5.03121C4.48967 13.5417 3.98189 13.2786 3.6696 12.8362L2.34607 10.9612C1.93933 10.3849 1.93933 9.61508 2.34607 9.03883L3.6696 7.16386C3.98189 6.72144 4.48967 6.45833 5.03121 6.45833H9.16758C9.62783 6.45833 10.0009 6.83143 10.0009 7.29167V13.5417ZM10.8342 3.125H14.9707C15.5122 3.125 16.02 3.38811 16.3323 3.83053L17.6558 5.70553C18.0626 6.28174 18.0626 7.05159 17.6558 7.62781L16.3323 9.50283C16.02 9.94525 15.5122 10.2083 14.9707 10.2083H10.8342C10.3741 10.2083 10.0009 9.83525 10.0009 9.375V3.95833C10.0009 3.4981 10.3741 3.125 10.8342 3.125Z" [attr.stroke]="openedFilters.includes('region') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('region')">
                                    {{'COMMON.BU.SINGLE' | translate}} & {{'COMMON.UT.SINGLE' | translate}}
                                </span>
                            </div>
                            <img
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg"
                                alt="Dropdown"
                                [class.open]="openedFilters.includes('region')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('region')" class="filter-section">
                            <div class="region-area-container">
                                <div class="region-column">
                                    <div class="search-row">
                                        <input
                                        type="text"
                                        placeholder="Search by region"
                                        [(ngModel)]="regionSearchText"
                                        (ngModelChange)="updateAreas()"
                                        />
                                    </div>
                                    <div class="region-list">
                                        <div *ngFor="let region of filteredRegions" class="region-item">
                                            <div
                                                class="region-header"
                                                [class.selected]="selectedRegion?.id === region.id"
                                                (click)="selectRegion(region)"
                                            >
                                                <span>{{ region.name }}</span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill="none" d="M6 12L10 8L6 4" stroke="currentColor" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="selectedRegion != null" class="area-column">
                                <div class="search-row">
                                    <input
                                    type="text"
                                    placeholder="Search by district"
                                    [(ngModel)]="districtSearchText"
                                    (ngModelChange)="updateAreas()"
                                    />
                                </div>
                                <div class="area-list">
                                    <div *ngFor="let area of areas" class="area-item">
                                    <input type="checkbox" [checked]="isAreaSelected({id: area.id, name: area.name})" (change)="onAreaSelect({id: area.id, name: area.name}, $event)"/>
                                    <span>{{ area.name }}</span>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <!-- Tariff Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('tariff')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0009 13.5417V16.875M10.0009 13.5417H5.03121C4.48967 13.5417 3.98189 13.2786 3.6696 12.8362L2.34607 10.9612C1.93933 10.3849 1.93933 9.61508 2.34607 9.03883L3.6696 7.16386C3.98189 6.72144 4.48967 6.45833 5.03121 6.45833H9.16758C9.62783 6.45833 10.0009 6.83143 10.0009 7.29167V13.5417ZM10.8342 3.125H14.9707C15.5122 3.125 16.02 3.38811 16.3323 3.83053L17.6558 5.70553C18.0626 6.28174 18.0626 7.05159 17.6558 7.62781L16.3323 9.50283C16.02 9.94525 15.5122 10.2083 14.9707 10.2083H10.8342C10.3741 10.2083 10.0009 9.83525 10.0009 9.375V3.95833C10.0009 3.4981 10.3741 3.125 10.8342 3.125Z" [attr.stroke]="openedFilters.includes('tariff') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('tariff')">
                                    {{'COMMON.TARIFF.SINGLE' | translate}}
                                </span>
                            </div>
                            <img
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg"
                                alt="Dropdown"
                                [class.open]="openedFilters.includes('tariff')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('tariff')" class="filter-section tariff-filter-section">
                            <div class="dropdown filter-window-dropdown">
                                <div>
                                    <div class="feeder-search-bar filter-search-bar">
                                        <img
                                            src="assets/icons/search.svg"
                                            alt="Search icon"
                                            class="search-icon"
                                        />
                                        <input
                                            type="text"
                                            class="feeder-search-input"
                                            placeholder="Search Tariffs"
                                            [(ngModel)]="tariffSearchText"
                                            (input)="filterTariffs()"
                                        />
                                    </div>
                                    <div class="options-container">
                                        <div *ngFor="let tariff of filteredTariffs" (click)="selectTariff(tariff)" class="dropdown-option">
                                            <span>{{ tariff.name| hasValue }}</span>
                                            <svg *ngIf="selectedTariff?.id === tariff.id" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <!-- Client Type Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('client-type')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="openedFilters.includes('client-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>                                      
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="openedFilters.includes('client-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('client-type')">
                                    {{"COMMON.MBC_DETAILS.CLIENT_TYPE" | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('client-type')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('client-type')" class="user-type-filter-section">
                            <label *ngFor="let option of clientTypes">
                                <input
                                    type="radio"
                                    name="customerType"
                                    [value]="option.value"
                                    [checked]="selectedClientType === option.value"
                                    (change)="selectClientType(option.value)"
                                />
                                <span class="option">{{ option.label.toUpperCase() | translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>

                <!-- Service Type Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('service-type')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>                                      
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('service-type')">
                                    {{"COMMON.SERVICE_TYPE.TITLE" | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('service-type')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('service-type')" class="user-type-filter-section">
                            <label *ngFor="let option of serviceTypes">
                                <input
                                    type="radio"
                                    name="serviceType"
                                    [value]="option.value"
                                    [checked]="selectedServiceType === option.value"
                                    (change)="selectServiceType(option.value)"
                                />
                                <span class="option">{{ option.label.toUpperCase() | translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>

                <!-- SLT Status Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('slt-status')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>                                      
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('slt-status')">
                                    {{"CRUD.SLT_STATUS" | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('slt-status')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('slt-status')" class="filter-section tariff-filter-section">
                            <div class="dropdown filter-window-dropdown">
                                <div>
                                    <div class="feeder-search-bar filter-search-bar">
                                        <img
                                            src="assets/icons/search.svg"
                                            alt="Search icon"
                                            class="search-icon"
                                        />
                                        <input
                                            type="text"
                                            class="feeder-search-input"
                                            placeholder="Search Slts"
                                            [(ngModel)]="sltSearchText"
                                            (input)="filterSltOptions()"
                                        />
                                    </div>
                                    <div class="options-container">
                                        <div *ngFor="let slt of filteredSltOptions" (click)="selectSltStatus(slt)" class="dropdown-option">
                                            <span>{{ slt.value| hasValue }}</span>
                                            <svg *ngIf="selectedSltStatus === slt.key" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2 6L5 9L10 3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <!-- Status Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('status')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>                                      
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('status')">
                                    {{"COMMON.VALIDATION_STATUS" | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('status')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('status')" class="user-type-filter-section">
                            <label *ngFor="let status of statusOptions">
                                <input
                                    type="radio"
                                    name="status"
                                    [value]="status.value"
                                    [checked]="selectedStatus === status.value"
                                    (change)="selectStatus(status.value)"
                                />
                                <span class="option">{{ status.label.toUpperCase() | translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>

                <!-- Phase Filter -->
                <li>
                    <div class="filter-item">
                        <div class="filter-header" (click)="toggleFilter('phase')">
                            <div class="img-title-container">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>                                      
                                    <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z" [attr.stroke]="openedFilters.includes('customer-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round"/>
                                </svg>
                                <span class="filter-title" [class.date-open]="openedFilters.includes('phase')">
                                    {{"COMMON.CUSTOMER.CUSTOMER_PHASE" | translate}}
                                </span>
                            </div>
                            <img 
                                src="../../../assets/icons/ng_v3/dropdown-icon.svg" 
                                alt="Dropdown" 
                                [class.open]="openedFilters.includes('phase')"
                            />
                        </div>
                        <div *ngIf="openedFilters.includes('phase')" class="user-type-filter-section">
                            <label *ngFor="let phase of phaseOptions">
                                <input
                                    type="radio"
                                    name="phase"
                                    [value]="phase.value"
                                    [checked]="selectedPhase === phase.value"
                                    (change)="selectPhase(phase.value)"
                                />
                                <span class="option">{{ phase.label.toUpperCase() | translate }}</span>
                            </label>
                        </div>
                    </div>
                </li>        
            </ul>
         </div>
         <div class="drawer-footer">
            <button class="cancel-btn" (click)="onCancel()">{{'COMMON.CANCEL' | translate }}</button>
            <button class="add-filter-btn" (click)="onAddFilter()">{{'COMMON.ADD_FILTER.SINGLE' | translate}}</button>
        </div>
    </div>
</div>